import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { ButtonBase } from '../Button/ButtonBase/index.js';
import { TagIcon } from '../Tag/TagIcon.js';
import { TagLabel } from '../Tag/TagLabel.js';

var TagButton = function (_a) {
    var children = _a.children, iconLeft = _a.iconLeft, infoIcon = _a.infoIcon, iconRight = _a.iconRight, actionIcon = _a.actionIcon, _b = _a.tone, tone = _b === void 0 ? "secondary" : _b, _c = _a.size, size = _c === void 0 ? "md" : _c, props = __rest(_a, ["children", "iconLeft", "infoIcon", "iconRight", "actionIcon", "tone", "size"]);
    return (jsxs(ButtonBase, __assign({ themeKey: "tagButton", size: size, tone: tone }, props, { children: [(!!iconLeft || !!infoIcon) && (jsx(TagIcon, __assign({ position: "left", size: size }, { children: iconLeft || infoIcon }))), jsx(TagLabel, { children: children }), (!!iconRight || !!actionIcon) && (jsx(TagIcon, __assign({ look: "action", position: "right", size: size }, { children: iconRight || actionIcon })))] })));
};

export { TagButton };
//# sourceMappingURL=TagButton.js.map
